import { Button, Grid } from "@mui/material";
import { useState, useContext, useEffect } from "react";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { LocaleContext } from "../../../../../routing/LangRouter";
import axios from "axios";
import BASE_URL from "../../../../../constants/baseUrls";
import cookie from "js-cookie";
import { ToastContainer, toast } from "react-toastify";

//styles
import "./location-point.scss";

function LocationPoint() {
    const { locale } = useContext(LocaleContext);
    const accessToken = localStorage.getItem("accessToken");
    const navigate = useNavigate();
    let [searchParams] = useSearchParams();
    const [radioValue, setRadioValue] = useState([]);

    //get question location point page
    const [locationPointList, setLocationPointList] = useState(null);
    const getLocationPointList = async () => {
        const response = await axios.get(`${BASE_URL}/g5znsh6vtyic3w5/location/points/`, {
            params: {
                action: "getQuests",
                pk: searchParams.get("id"),
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        const categories = response.data;
        let tempList = [];
        categories.forEach(category => {
            category.sub_categories.forEach(subCat => {
                subCat.active = false;
                subCat.question.forEach(qu => {
                    qu.values.forEach(value => {
                        if (value.active) {
                            let listItem = {};
                            listItem.category_id = category.id;
                            listItem.sub_category_id = subCat.id;
                            listItem.key = qu.key;
                            listItem.value = value.value;
                            tempList.push(listItem);
                        }
                    });
                });
            });
        });
        setLocationPointList(categories);
        setRadioValue([...radioValue, ...tempList]);
    };
    useEffect(() => {
        getLocationPointList();
    }, []);

    const goToAdminLocation = () => {
        navigate(`/${locale}/admin-panel/locations-managment`);
    };

    //sub category
    const handleSubCategoryChange = (event, categoryId) => {
        const { value } = event.target;
        setLocationPointList(categories => {
            const newCategoryList = categories.map(category => {
                if (category.id === categoryId) {
                    category.sub_categories.map(subCategory => {
                        if (subCategory.id === parseInt(value)) {
                            subCategory.active = true;
                            return subCategory;
                        } else {
                            subCategory.active = false;
                            return subCategory;
                        }
                    });
                }
                return category;
            });
            return newCategoryList;
        });
    };

    //set answers
    const handleQuestionChange = (event, category, subCategory) => {
        const keyCurrent = event.target.name;
        const key = keyCurrent.split(".")[0];
        const value = event.target.value;
        let isRepeat = false;
        radioValue.forEach(value => {
            if (value.category_id === category && value.sub_category_id === subCategory && value.key === key) {
                isRepeat = true;
                return;
            }
        });
        // setRadioValue((values)=>([...values,{ key:key, value:value}]))
        // if(radioValues)
        if (!isRepeat) setRadioValue([...radioValue, { category_id: category, sub_category_id: subCategory, key: key, value: value }]);
        else
            setRadioValue(values => {
                const newArray = values.map(item => {
                    if (item.category_id === category && item.sub_category_id === subCategory && item.key === key) {
                        item.value = value;
                        setLocationPointList(locationPoints => {
                            locationPoints.map(locationPoint => {
                                if (locationPoint.id == category)
                                    locationPoint.sub_categories.map(locationPointSubCat => {
                                        if (locationPointSubCat.id == subCategory)
                                            locationPointSubCat.question.map(locationPointQuestion => {
                                                if (locationPointQuestion.key == key)
                                                    locationPointQuestion.values.map(locationPointValue => {
                                                        if (locationPointValue.value == value) {
                                                            locationPointValue.active = true;
                                                        } else locationPointValue.active = false;
                                                        return locationPointValue;
                                                    });
                                            });
                                    });
                            });
                            return locationPoints;
                        });
                    }
                    return item;
                });
                return newArray;
            });
        // if (radioValue) {
        //     // setGenerateAnswers((values) => ({ ...values, category_id: category, sub_category_id: subCategory, questions: radioValue }))
        //     setGenerateAnswers([...generateAnswers,{category_id: category, sub_category_id: subCategory, questions: radioValue}])
        // }
    };

    //submit answers
    const submitPointForm = async event => {
        event.preventDefault();
        const data = radioValue;
        const response = await axios.post(`${BASE_URL}/g5znsh6vtyic3w5/location/points/`, data, {
            params: {
                action: "calcPoints",
                pk: searchParams.get("id"),
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        try {
            if (response.status === 200) {
                toast.success(response.data.message, { toastId: "custom-id-yes" });
            }
        } catch (error) {
            toast.error(response.data.message, { toastId: "custom-id-yes" });
        }
    };

    //go to location add page
    const goToAddPage = () => {
        const id = searchParams.get("id");
        const params = { id: id, isEditing: true };
        navigate({
            pathname: `/${locale}/admin-panel/location-add`,
            search: `?${createSearchParams(params)}`,
        });
    };

    return (
        <Grid className="location-point" container rowGap={3}>
            <ToastContainer rtl={true} theme="colored"></ToastContainer>
            <Grid container item xs={12} rowGap={1}>
                <Button variant="outlined" color="error" onClick={goToAdminLocation}>
                    بستن
                </Button>
            </Grid>
            <Grid className="location-add__form" component="form" onSubmit={submitPointForm} container rowGap={2}>
                <span>نام لوکیشن: {searchParams.get("name")}</span>
                {locationPointList
                    ? locationPointList.map(category => {
                          return (
                              <Grid className="location-point__content" key={category.id} container item xs={12} rowGap={4}>
                                  <Grid key={category.id} container item xs={12}>
                                      <h3>{category.persian_name}</h3>
                                  </Grid>
                                  {category?.sub_categories?.map(subCategories => {
                                      return (
                                          <Grid className="location-point__question" key={subCategories.id} container item xs={12} rowGap={3}>
                                              <Grid className="location-point__title-question" container item xs={12}>
                                                  <input
                                                      type="radio"
                                                      name={category.name}
                                                      value={subCategories.id}
                                                      onChange={event => handleSubCategoryChange(event, category.id)}
                                                  ></input>
                                                  <h5>{subCategories.persian_name}:</h5>
                                              </Grid>
                                              {subCategories?.question?.map((question, index) => {
                                                  return (
                                                      <Grid key={question.key}>
                                                          {subCategories.active ? (
                                                              <Grid container item xs={12} rowGap={1}>
                                                                  <Grid container item xs={12}>
                                                                      <span className="location-point__index">{index + 1}) </span>
                                                                      <span> {question.quest}</span>
                                                                  </Grid>
                                                                  {question?.values.map(value => {
                                                                      return (
                                                                          <Grid key={Math.random() + value.value} container item xs={12}>
                                                                              <input
                                                                                  type="radio"
                                                                                  name={question.key + "." + subCategories.id + category.id}
                                                                                  value={value.value}
                                                                                  checked={value.active}
                                                                                  onChange={event =>
                                                                                      handleQuestionChange(event, category.id, subCategories.id)
                                                                                  }
                                                                              ></input>
                                                                              <label>{value.text}</label>
                                                                          </Grid>
                                                                      );
                                                                  })}
                                                                  <input
                                                                      type="radio"
                                                                      name={question.key + "." + subCategories.id + category.id}
                                                                      value={null}
                                                                      onChange={event => handleQuestionChange(event, category.id, subCategories.id)}
                                                                  ></input>
                                                                  <label>هیچکدام</label>
                                                              </Grid>
                                                          ) : (
                                                              ""
                                                          )}
                                                      </Grid>
                                                  );
                                              })}
                                          </Grid>
                                      );
                                  })}
                              </Grid>
                          );
                      })
                    : ""}

                <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                    <Grid item xs={3.8}>
                        <Button variant="outlined" color="secondary" onClick={goToAddPage} fullWidth>
                            ویرایش
                        </Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button variant="contained" type="submit" color="success" fullWidth>
                            ثبت
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default LocationPoint;
